import React from "react";
import "../../App.css";
import BiltyInquiryForm from "../BiltyInquiry";

function BiltyInquiryPage({ sessionObject, itemNamesDict }) {
  if (
    !["bgtc", "ase"].includes(process.env.REACT_APP_CLIENT) &&
    !sessionObject.sessionVariables["modules"].includes("bilty-inquiry")
  ) {
    return;
  }

  return (
    <div className="page-bilty">
      <BiltyInquiryForm
        sessionObject={sessionObject}
        itemNamesDict={itemNamesDict}
      />
    </div>
  );
}

export default BiltyInquiryPage;